<template>
  <div>
    <PLink
      v-if="ctaType === 'link' && item.link_text && item.link_url.url"
      :link-object="blockLink(item.link_url, item.link_url_connected_user)"
      is-highlight
      color="bluko"
    >
      {{ blockLinkText(item.link_text, item.link_text_connected_user) }}
    </PLink>

    <PLink
      v-else-if="ctaType === 'mailto' && item.link_text && item.mailto"
      :simple-url="`mailto:${item.mailto}`"
      is-highlight
      color="bluko"
    >
      {{ item.link_text }}
    </PLink>

    <PLink
      v-else-if="ctaType === 'intercom' && item.link_text"
      simple-url="#/"
      is-highlight
      color="bluko"
      @on-click="showIntercom"
    >
      {{ item.link_text }}
    </PLink>
  </div>
</template>
<script>
import PLink from '~/components/PLink'
import { isLoggedIn } from '~/mixins/isLoggedIn'

export default {
  name: 'CtaBox',

  components: {
    PLink,
  },

  mixins: [isLoggedIn],

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ctaType() {
      return this.item.cta_type || 'link'
    },
  },

  methods: {
    blockLink(normalLink, connectedLink) {
      if (connectedLink?.url && this.isLoggedIn) return connectedLink

      return normalLink
    },

    blockLinkText(normalLinkText, connectedLinkText) {
      if (connectedLinkText && this.isLoggedIn) return connectedLinkText

      return normalLinkText
    },
    showIntercom() {
      if (window.Intercom) {
        window.Intercom('show')
      } else {
        window.Didomi.notice.show()
      }
    },
  },
}
</script>

<style lang="scss" module></style>
